module.exports = __webpack_public_path__ + "img/leadProcessed.8c6ea6ca.svg";